'use client';

import { HTMLMotionProps, motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styles from './Tile.module.scss';

export default function Tile({ children, ...props }: PropsWithChildren<HTMLMotionProps<'div'>>) {
  return (
    <motion.div
      className={styles.tile}
      whileHover={{
        color: 'var(--color-primary)',
        boxShadow: '0 0 15px #0002',
        borderRadius: 'var(--card-border-radius)',
        zIndex: 1,
        outline: '3px solid var(--color-primary)',
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
